import axios, {AxiosResponse} from 'axios'
import {API_BASE, API_URLS} from "@/utils/constants/api-urls.ts";
import {IGetResult} from "@/types/api.ts";
import type {Router} from "vue-router";
import ObjectChecker from "@/utils/ObjectChecker.ts";
import {useAuthStore} from "@/store/auth-store.ts";
import {push} from "notivue";

let router: Router | null = null
export const setAxiosRouter = (r: Router) => router = r
export const axiosInstance = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
})

axiosInstance.interceptors.response.use(
  async (response: AxiosResponse<IGetResult>) => {
    if (ObjectChecker.isNotEmptyOrNull(response.data?.data))
      useAuthStore().addApiPayload(response.data.data);
    if (response.data?.data?.function === "initUser")
      await useAuthStore().initUser();
    const redirectUrl = response.data.redirectUrl
    if (router && redirectUrl)
      await router.push(redirectUrl)
    const message = response.data?.message;
    let title = response.data?.title;
    if (ObjectChecker.isAnyNotEmptyOrNull(title, message)) {
      const messageType = response.data.messageType
      if (ObjectChecker.isNotEmptyOrNull(messageType))
        push[messageType]({
          title,
          message
        })
      else
        push.success({
          title,
          message
        })
    }
    return response;
  },
  async (error: any) => {
    const status = error.response?.status;
    const originalRequest = error.config;
    if (status === 401 && !originalRequest._retry &&
      !originalRequest.url?.includes(API_URLS.auth.refresh)) {
      originalRequest._retry = true;
      try {
        await axios.post(API_URLS.auth.refresh, {}, {withCredentials: true})
        return axiosInstance.request(error.config);
      } catch {
        return Promise.reject(error);
      }
    }
    const message = error.response?.data.message;
    if (message && status !== 401)
      push.error({
        title: error.response?.data?.title ?? 'فشل',
        message: message
      })
    const redirectUrl = error.response?.data.redirectUrl
    if (router && redirectUrl)
      await router.push(redirectUrl)
    return Promise.reject();
  }
)
